<template>
  <div class="warehouses container">
    <h2 class="title is-2">Carico Prodotti</h2>
    <form v-if="isCoordinator" class="form form__estate-filter" autocomplete="off" @submit.prevent="perform">
      <b-field label="Tenute">
        <b-select @change.native="getWarehouseInventory" v-model='selectedEstateId' icon="globe" icon-pack="fas"
                  placeholder="Seleziona la tenuta"
                  expanded>
          <option v-for="(estate) in estates"
                  :value="estate.id"
                  :key="estate.id">{{ estate.name }} </option>
        </b-select>
      </b-field>
    </form>
    <b-tabs v-model="activeTab">
      <b-tab-item label="Prodotti">
        <nav class="level level-right">
          <b-tooltip label="Nuovo DDT" class="is-left">
            <router-link
              class="button button--warehouse-add-products is-primary"
              :event="selectedEstateId && warehouse.id > 0 ? 'click' : ''"
              :disabled="typeof selectedEstateId === 'undefined' || !warehouse.id"
              :to="{name: 'AddProducts', params: {estateId: selectedEstateId, id: warehouse.id}}">
              <b-icon icon="plus"></b-icon>
              <span>DDT</span>
            </router-link>
          </b-tooltip>
        </nav>
        <table-component :show-caption="false" :data="warehouse.products" sort-by="description" sort-order="asc">
          <table-column label="Codice" show="sku"></table-column>
          <table-column label="Descrizione" show="description"></table-column>
          <table-column label="Quantità (kg/l)" show="quantity"></table-column>
        </table-component>
      </b-tab-item>
    </b-tabs>

  </div>
</template>

<script>
  import {mapGetters, mapState} from 'vuex'
  import {api, utils} from '../../../helpers/'
  import BTooltip from 'buefy/src/components/tooltip/Tooltip'

  export default {
    name: 'Warehouses',
    components: {BTooltip},
    data: () => {
      return {
        activeTab: 0,
        estates: [],
        selectedEstateId: null,
        warehouse: {
          id: 0,
          products: []
        }
      }
    },
    computed: {
      ...mapGetters('auth', {
        isCoordinator: 'isCoordinator',
        isManager: 'isManager',
        isLeader: 'isLeader',
        isWorkman: 'isWorkman'
      }),
      ...mapState('auth', {
        role: 'role',
        estateIds: 'estateIds'
      })
    },
    methods: {
      getWarehouseInventory (event) {
        this.selectedEstateId = event.target.value
        this.callGetWarehouseInventory(this.selectedEstateId)
      },
      callGetWarehouseInventory (aEstateId) {
        const modal = this.$loading.open()
        api.getWarehousesStockInventory(aEstateId, true)
          .then(response => {
            this.warehouse.id = response.id
            this.warehouse.products = response.products
            modal.close()
          }).catch(errors => utils.errors(errors, modal))
      },
      perform () {
        console.log('Perform')
      }
    },
    mounted () {
      if (typeof this.$route.params.estateId !== 'undefined') {
        this.selectedEstateId = this.$route.params.estateId
      } else {
        this.selectedEstateId = this.isCoordinator ? 0 : (this.estateIds[0] || 0)
      }

      if (this.selectedEstateId) {
        this.callGetWarehouseInventory(this.selectedEstateId)
      }

      api.getEstates()
        .then(response => {
          this.estates = response.filter(estate => {
            let item = this.estateIds.find(id => estate.id === id)
            return typeof item !== 'undefined'
          })
        })
        .then(() => {
          // has one estate only
          if (this.estates.length === 1) {
            this.selectedEstateId = this.estates[0].id
          }
        })
        .catch(errors => utils.errors(errors))
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/views/warehouses/Warehouses.vue